import { render, staticRenderFns } from "./select-datasource.vue?vue&type=template&id=7667bcc8&scoped=true"
import script from "./select-datasource.vue?vue&type=script&lang=js"
export * from "./select-datasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7667bcc8",
  null
  
)

export default component.exports